import { withOktaAuth } from '@okta/okta-react';
import React, { Component } from 'react';
import config from './config';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { countryArrray } from './Utils/country.js';
import { jobfamilies } from './Utils/jobfamilies.js';
import Alert from './components/Alert';

export default withOktaAuth(class Home extends Component {
  constructor() {
    super();
    this.timeout = null;
    this.scrollTimeout = null;

    this.state = {
      isAuthenticated: false,
      showIntuitiveResults: true,
      results: [],
      CSVExportResults: [],
      intuitiveResults: [],
      scrollY: 0,
      scrolled: 0,
      index: 1,
      noMoreResult: false,
      limit: 30,
      globalQuery: localStorage.getItem("globalQuery") ? localStorage.getItem("globalQuery") : "",
      employeeTypeQuery: localStorage.getItem("employeeTypeQuery") ? localStorage.getItem("employeeTypeQuery") : "",
      groupIdQuery: localStorage.getItem("groupIdQuery") ? localStorage.getItem("groupIdQuery") : "",
      companyQuery: localStorage.getItem("companyQuery") ? localStorage.getItem("companyQuery") : "",
      entityQuery: localStorage.getItem("entityQuery") ? localStorage.getItem("entityQuery") : "",
      firstNameQuery: localStorage.getItem("firstNameQuery") ? localStorage.getItem("firstNameQuery") : "",
      lastNameQuery: localStorage.getItem("lastNameQuery") ? localStorage.getItem("lastNameQuery") : "",
      primaryPhoneQuery: localStorage.getItem("primaryPhoneQuery") ? localStorage.getItem("primaryPhoneQuery") : "",
      C_businessCategoryQuery: localStorage.getItem("C_businessCategoryQuery") ? localStorage.getItem("C_businessCategoryQuery") : "",
      C_countryNameQuery: localStorage.getItem("C_countryNameQuery") ? localStorage.getItem("C_countryNameQuery") : "",
      cityQuery: localStorage.getItem("cityQuery") ? localStorage.getItem("cityQuery") : "",
      C_houseIdentifierQuery: localStorage.getItem("C_houseIdentifierQuery") ? localStorage.getItem("C_houseIdentifierQuery") : "",
      titleQuery: localStorage.getItem("titleQuery") ? localStorage.getItem("titleQuery") : "",
      gbuQuery: localStorage.getItem("gbuQuery") ? localStorage.getItem("gbuQuery") : "",
      GBUs: [],
      ready: false,
      isLoadingMore: false,
      alert: null,
      enum: {
        Countries: countryArrray,
        JobFamilies: jobfamilies
      },
      searchcss: "form-row",
    };
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClick = this.handleClick.bind(this);

    this.setCsvInstance = this.setCsvInstance.bind(this);
  }

  async componentDidMount() {
    document.addEventListener('click', this.handleClick);
    window.addEventListener('scroll', this.handleScroll);
    this.setState({ isAuthenticated: this.props.authState?.isAuthenticated }, () => {
      this.getGBUs();
      this.getInfo();
    });
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevProps?.authState && this.props?.authState && prevProps.authState.isAuthenticated !== this.props.authState.isAuthenticated) {
      this.setState({ isAuthenticated: this.props.authState?.isAuthenticated });
    }
  }

  async componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    document.removeEventListener('click', this.handleClick);
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }
  }

  showAlert(type, title, message) {
    this.setState({
      alert: { type, title, message }
    });
    // Auto-hide alert after 5 seconds
    setTimeout(() => {
      this.setState({ alert: null });
    }, 5000);
  }

  hideAlert() {
    this.setState({ alert: null });
  }

  async getInfo() {
    // Pour le scroll infini, on utilise isLoadingMore au lieu de ready
    if (this.state.index === 0) {
      this.setState({ ready: false });
    } else {
      this.setState({ isLoadingMore: true });
    }
    
    if (this.state.showIntuitiveResults) {
      this.handleClick();
    }
    try {
      const accessToken = this.props.authState.accessToken.accessToken;
      let url = new URL(config.env.resourceServer.getOktaUsersUrl);

      //Handle Global Search
      let formatedGlobalQuery = this.state.globalQuery ? this.state.globalQuery.slice() : "";
      let updatedGroupIdQuery = "";
      let updatedPhoneNumberQuery = "";
      let updatedGBUQuery = "";
      let updatedCountryQuery = "";

      //Handle GroupID format
      if (this.state.globalQuery.match(/^([a-zA-Z]{2}[0-9]{4})(-[a-zA-Z])?$|^([a-zA-Z]{3}[0-9]{3})(-[a-zA-Z])?$|^([a-zA-Z]{4}[0-9]{2})(-[a-zA-Z])?$/g)) {
        updatedGroupIdQuery = formatedGlobalQuery.slice();
        formatedGlobalQuery = "";
      } else if (this.state.globalQuery.match(/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s0-9]*$/g)) {
        //Handle phone number format
        updatedPhoneNumberQuery = formatedGlobalQuery.substr(0, 1) === "0" ? formatedGlobalQuery.slice(1).replace(/[^0-9]/g, "") : formatedGlobalQuery.slice().replace(/[^0-9]/g, "");
        formatedGlobalQuery = "";
      } else if (this.state.GBUs.find(gbu => gbu.Name.replace(/\s/g, '').toUpperCase() === this.state.globalQuery.replace(/\s/g, '').toUpperCase() || gbu.Code.toUpperCase() === this.state.globalQuery.replace(/\s/g, '').toUpperCase())) {
        //Handle for GBUs
        updatedGBUQuery = this.state.GBUs.find(gbu => gbu.Name.replace(/\s/g, '').toUpperCase() === this.state.globalQuery.replace(/\s/g, '').toUpperCase() || gbu.Code.toUpperCase() === this.state.globalQuery.replace(/\s/g, '').toUpperCase()).Code;
        formatedGlobalQuery = "";
      }
      // else if (this.state.enum.Countries.find(co => co.name.replace(/\s/g, '').toUpperCase() === this.state.globalQuery.replace(/\s/g, '').toUpperCase() || co.id.toUpperCase() === this.state.globalQuery.replace(/\s/g, '').toUpperCase())) {
      //   //Handle for Countries
      //   updatedCountryQuery = this.state.enum.Countries.find(co => co.name.replace(/\s/g, '').toUpperCase() === this.state.globalQuery.replace(/\s/g, '').toUpperCase() || co.id.toUpperCase() === this.state.globalQuery.replace(/\s/g, '').toUpperCase()).name;
      //   formatedGlobalQuery = "";
      // }

      let params = {
        globalQuery: formatedGlobalQuery,
        groupIdQuery: this.state.groupIdQuery ? this.state.groupIdQuery : updatedGroupIdQuery,
        companyQuery: this.state.companyQuery,
        entityQuery: this.state.entityQuery,
        firstNameQuery: this.state.firstNameQuery,
        lastNameQuery: this.state.lastNameQuery,
        primaryPhoneQuery: this.state.primaryPhoneQuery ? this.state.primaryPhoneQuery : updatedPhoneNumberQuery,
        C_businessCategoryQuery: this.state.C_businessCategoryQuery,
        C_countryNameQuery: this.state.C_countryNameQuery ? this.state.C_countryNameQuery : updatedCountryQuery,
        cityQuery: this.state.cityQuery,
        C_houseIdentifierQuery: this.state.C_houseIdentifierQuery,
        titleQuery: this.state.titleQuery,
        employeeTypeQuery: this.state.employeeTypeQuery,
        gbuQuery: this.state.gbuQuery ? this.state.gbuQuery : updatedGBUQuery,
        limit: this.state.limit,
        after: (this.state.index - 1) * this.state.limit
      }
      url.search = new URLSearchParams(params);
      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });

      if (response.status !== 200) {
        this.setState({ failed: true, ready: true, isLoadingMore: false });
        this.showAlert('error', 'Search Failed', 'Unable to perform search. Please try again later.');
        return;
      }

      const data = await response.json();
      let results = this.state.results;
      data.forEach((element) => {
        results.push(element);
      });

      data.length < this.state.limit ?
        this.setState({ results: results, failed: false, noMoreResult: true }) :
        this.setState({ results: results, failed: false, noMoreResult: false });

      // Show success message only on first search (index 1)
      // if (this.state.index === 1 && data.length > 0) {
      //   this.showAlert('success', 'Search Completed', `Found ${data.length} result${data.length > 1 ? 's' : ''} matching your criteria.`);
      // }

      data.forEach((element) => {
        this.getPhoto(element.login);
      });
    } catch (err) {
      this.setState({ failed: true, ready: true, isLoadingMore: false });
      this.showAlert('error', 'Search Error', 'An unexpected error occurred during search. Please try again.');
      /* eslint-disable no-console */
      console.error(err);
    }
    this.setState({ ready: true, isLoadingMore: false });
  }

  async getGBUs() {
    try {
      var currentAccessToken = this.props.authState.accessToken.accessToken;
      const response = await fetch(config.env.resourceServer.getGBUsUrl + "?Status=Valid&order=Name ASC&select=Name,Code&index=0&itemPerPage=1000", {
        headers: {
          Authorization: `Bearer ${currentAccessToken}`
        },
      });

      if (response.status !== 200) {
        return;
      }

      const data = await response.json();
      this.setState({ GBUs: data });
    } catch (err) {
      console.error(err);
    }
  }

  async getCSVExportInfo() {
    try {
      document.getElementById("CSVExportButton").disabled = true;
      const accessToken = this.props.authState.accessToken.accessToken;
      let url = new URL(config.env.resourceServer.getOktaUsersUrl);

      //Handle Global Search
      let formatedGlobalQuery = this.state.globalQuery ? this.state.globalQuery.slice() : "";
      let updatedGroupIdQuery = "";
      let updatedPhoneNumberQuery = "";
      let updatedGBUQuery = "";
      let updatedCountryQuery = "";

      //Handle GroupID format
      if (this.state.globalQuery.match(/^([a-zA-Z]{2}[0-9]{4})(-[a-zA-Z])?$|^([a-zA-Z]{3}[0-9]{3})(-[a-zA-Z])?$|^([a-zA-Z]{4}[0-9]{2})(-[a-zA-Z])?$/g)) {
        updatedGroupIdQuery = formatedGlobalQuery.slice();
        formatedGlobalQuery = "";
      } else if (this.state.globalQuery.match(/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s0-9]*$/g)) {
        //Handle phone number format
        updatedPhoneNumberQuery = formatedGlobalQuery.substr(0, 1) === "0" ? formatedGlobalQuery.slice(1).replace(/[^0-9]/g, "") : formatedGlobalQuery.slice().replace(/[^0-9]/g, "");
        formatedGlobalQuery = "";
      } else if (this.state.GBUs.find(gbu => gbu.Name.replace(/\s/g, '').toUpperCase() === this.state.globalQuery.replace(/\s/g, '').toUpperCase() || gbu.Code.toUpperCase() === this.state.globalQuery.replace(/\s/g, '').toUpperCase())) {
        //Handle for GBUs
        updatedGBUQuery = this.state.GBUs.find(gbu => gbu.Name.replace(/\s/g, '').toUpperCase() === this.state.globalQuery.replace(/\s/g, '').toUpperCase() || gbu.Code.toUpperCase() === this.state.globalQuery.replace(/\s/g, '').toUpperCase()).Code;
        formatedGlobalQuery = "";
      }
      // else if (this.state.enum.Countries.find(co => co.name.replace(/\s/g, '').toUpperCase() === this.state.globalQuery.replace(/\s/g, '').toUpperCase() || co.id.toUpperCase() === this.state.globalQuery.replace(/\s/g, '').toUpperCase())) {
      //   //Handle for Countries
      //   updatedCountryQuery = this.state.enum.Countries.find(co => co.name.replace(/\s/g, '').toUpperCase() === this.state.globalQuery.replace(/\s/g, '').toUpperCase() || co.id.toUpperCase() === this.state.globalQuery.replace(/\s/g, '').toUpperCase()).name;
      //   formatedGlobalQuery = "";
      // }

      let params = {
        globalQuery: formatedGlobalQuery,
        groupIdQuery: this.state.groupIdQuery ? this.state.groupIdQuery : updatedGroupIdQuery,
        companyQuery: this.state.companyQuery,
        entityQuery: this.state.entityQuery,
        firstNameQuery: this.state.firstNameQuery,
        lastNameQuery: this.state.lastNameQuery,
        primaryPhoneQuery: this.state.primaryPhoneQuery ? this.state.primaryPhoneQuery : updatedPhoneNumberQuery,
        C_businessCategoryQuery: this.state.C_businessCategoryQuery,
        C_countryNameQuery: this.state.C_countryNameQuery ? this.state.C_countryNameQuery : updatedCountryQuery,
        cityQuery: this.state.cityQuery,
        C_houseIdentifierQuery: this.state.C_houseIdentifierQuery,
        titleQuery: this.state.titleQuery,
        employeeTypeQuery: this.state.employeeTypeQuery,
        gbuQuery: this.state.gbuQuery ? this.state.gbuQuery : updatedGBUQuery,
        limit: 1000,
        after: 0
      }
      url.search = new URLSearchParams(params);
      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });

      const data = await response.json();
      let results = [];
      data.forEach((element) => {
        results.push(element);
      });

      this.setState({ CSVExportResults: results })

      if (this.csvInstanceRef && this.csvInstanceRef.link) {
        this.csvInstanceRef.link.click();
      }

      setTimeout(function () {
        document.getElementById('CSVExportButton').disabled = false;
      }, 2000);

    } catch (err) {
      /* eslint-disable no-console */
      console.error(err);
    }
  }

  async getPhoto(userId) {
    try {
      const accessToken = this.props.authState.accessToken.accessToken;
      const response = await fetch(config.env.resourceServer.getOktaUserPhotoUrl + "?userId=" + userId + "&size=240x240", {
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
      });

      if (response.status !== 200) {
        return;
      }

      const data = await response.json();
      if (!data.error) {
        let domUser = document.getElementById(userId);
        if (domUser) {
          domUser.src = data.image;
        }
      }
    } catch (err) {
      console.error(err);
    }
  }

  async getIntuitivePhoto(userId) {
    try {
      const accessToken = this.props.authState.accessToken.accessToken;
      const response = await fetch(config.env.resourceServer.getOktaUserPhotoUrl + "?userId=" + userId + "&size=240x240", {
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
      });

      const data = await response.json();

      let domUser = document.getElementById(`intuitive-${userId}`);
      if (domUser) {
        domUser.src = data.image ? data.image : "img/default_profile_photo.png";
      }
    } catch (err) {
      console.error(err);
    }
  }

  async getIntuitiveInfo() {
    try {
      let results = [];
      this.setState({ intuitiveResults: results });
      const accessToken = this.props.authState.accessToken.accessToken;
      let url = new URL(config.env.resourceServer.getOktaUsersUrl);

      let formatedGlobalQuery = this.state.globalQuery ? this.state.globalQuery.slice() : "";
      let updatedGroupIdQuery = "";
      let updatedPhoneNumberQuery = "";

      //Handle GroupID format
      if (this.state.globalQuery.match(/^([a-zA-Z]{2}[0-9]{4})(-[a-zA-Z])?$|^([a-zA-Z]{3}[0-9]{3})(-[a-zA-Z])?$|^([a-zA-Z]{4}[0-9]{2})(-[a-zA-Z])?$/g)) {
        updatedGroupIdQuery = formatedGlobalQuery.slice();
        formatedGlobalQuery = "";
      } else if (this.state.globalQuery.match(/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s0-9]*$/g)) {
        //Handle phone number format
        updatedPhoneNumberQuery = formatedGlobalQuery.substr(0, 1) === "0" ? formatedGlobalQuery.slice(1).replace(/[^0-9]/g, "") : formatedGlobalQuery.slice().replace(/[^0-9]/g, "");
        formatedGlobalQuery = "";
      }

      let params = {
        globalQuery: formatedGlobalQuery,
        groupIdQuery: updatedGroupIdQuery,
        primaryPhoneQuery: updatedPhoneNumberQuery,
        limit: 3,
        after: 0
      }
      url.search = new URLSearchParams(params);
      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });

      const data = await response.json();
      data.forEach((element) => {
        results.push(element);
      });

      this.setState({ intuitiveResults: results });

      data.forEach((element) => {
        this.getIntuitivePhoto(element.login);
      });
    } catch (err) {
      /* eslint-disable no-console */
      console.error(err);
    }
  }

  handleScroll = () => {
    // Clear existing timeout
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }

    // Debounce scroll events
    this.scrollTimeout = setTimeout(() => {
      let scrollY = window.scrollY || document.documentElement.scrollTop;

      // Handle search bar styling
      if (scrollY > 120) {
        this.setState({ searchcss: "form-row container fixed-search" });
      } else {
        this.setState({ searchcss: "form-row container" });
      }

      // Improved scroll-to-bottom detection with threshold
      const threshold = 100; // Load more when 100px from bottom
      const isNearBottom = (window.innerHeight + window.scrollY) >= (document.documentElement.scrollHeight - threshold);

      if (isNearBottom && this.state.ready && !this.state.noMoreResult && !this.state.failed && !this.state.isLoadingMore) {
        this.setState({
          scrolled: (this.state.scrolled + this.state.limit),
          index: (this.state.index + 1),
          scrollY: scrollY
        },() => {
          this.getInfo();
        });
      }
    }, 100); // 100ms debounce
  }

  handleAdvancedSearchSubmit = () => {
    this.setState({ scrolled: 0, scrollY: 0, index: 1, results: [], isLoadingMore: false });
    this.getInfo();
  }

  handleInputChange = (e) => {
    let stateObj = this.state;
    stateObj[e.target.id] = e.target.value;
    this.setState({ [e.target.id]: e.target.value });
    // if (e.target.id === "globalQuery" && e.target.value.length > 2) {
    //   clearTimeout(this.timeout);

    //   // Make a new timeout set to go off in 800ms
    //   this.timeout = setTimeout(() => {
    //     this.getIntuitiveInfo();
    //     if (!this.state.showIntuitiveResults) {
    //       this.setState({ showIntuitiveResults: true });
    //     }
    //   }, 500);
    // }
    localStorage.setItem(e.target.id, e.target.value);
  }

  handleClick() {
    if (this.state.showIntuitiveResults) {
      const currentState = this.state.showIntuitiveResults;
      this.setState({ showIntuitiveResults: !currentState });
    }
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  setCsvInstance(node) {
    this.csvInstanceRef = node;
  }

  showFilters = () => {
    const currentState = this.state.showFilters;
    this.setState({ showFilters: !currentState });
  }

  clearFilters = () => {
    this.setState({
      globalQuery: "",
      employeeTypeQuery: "",
      groupIdQuery: "",
      companyQuery: "",
      entityQuery: "",
      firstNameQuery: "",
      lastNameQuery: "",
      primaryPhoneQuery: "",
      C_businessCategoryQuery: "",
      C_countryNameQuery: "",
      cityQuery: "",
      C_houseIdentifierQuery: "",
      titleQuery: "",
      gbuQuery: "",
      results: [],
      index: 1,
      isLoadingMore: false
    }, () => this.getInfo());

  }

  getFormattedDateTime() {
    var date = new Date().toJSON().slice(0, 10);
    var time = new Date().toJSON().slice(11, 19);
    return date + "-" + time;
  }

  render() {
    return (
      <div>
        {/* Alert Display */}
        {this.state.alert && (
          <div className="alert-container">
            <Alert
              type={this.state.alert.type}
              title={this.state.alert.title}
              message={this.state.alert.message}
              onClose={() => this.hideAlert()}
            />
          </div>
        )}
        
        {!this.state.ready && (
          <div className="page-loading">
            <div className="loading-spinner"></div>
            <p className="loading-text"><FormattedMessage id="loading.search" defaultMessage="Searching..." /></p>
          </div>
        )}
        {this.state.ready && (
          <div>
            {!this.state.isAuthenticated &&
              <div className="alert-container">
                <Alert
                  type="warning"
                  title="Authentication Required"
                  message="You need to be logged in to access Engie Directory."
                />
              </div>
            }
            {(this.state.ready || this.state.index > 1) &&
              <div>
                <section className="hero-section bg-light page-inner">
                  <div className="overlay engiegradient-background"></div>
                  <div className="hero-banner-wrapper">
                    <div className="container">
                      <div className="row">
                        <div className="col-md-8 breadcrumb-col">
                          <div className="page-title no-bottom-space">
                            <nav className="breadcrumb-wrapper compact">
                              <div className="breadcrumb-modern compact breadcrumb-flex-center">
                                <Link to="/" className="breadcrumb-link breadcrumb-item"><FormattedMessage id="breadcrumb.home" defaultMessage="Home" /></Link>
                                <span className="breadcrumb-separator">/</span>
                                <span className="breadcrumb-item breadcrumb-current"><FormattedMessage id="breadcrumb.results" defaultMessage="Results" /></span>
                              </div>
                            </nav>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            }
            <section className="content-section bg-light">
              <div className="container">
                <div className="row">
                  <form className="col-md-12 filterform" onSubmit={(e) => { e.preventDefault(); this.handleAdvancedSearchSubmit(); }}>
                    <div className={this.state.searchcss}>
                      <div className="form-group col-md-10">
                        <input type="text" className="form-control" value={this.state.globalQuery} onChange={this.handleInputChange} id="globalQuery" autoComplete="off" />
                        {/* {this.state.intuitiveResults.length > 0 &&
                        <div className={this.state.showIntuitiveResults ? "dropdown-menu intuitive-menu show" : "dropdown-menu"}>
                          {this.state.intuitiveResults.map((element) => {
                            var a = this.state.intuitiveResults.indexOf(element);
                            return <Link ref={this.setWrapperRef} key={a} to={`/profile?userId=${encodeURIComponent(element.login)}`} className="dropdown-item intuitive-result">
                              <div className="profile-img intuitive-img">
                                <img
                                  id={"intuitive-" + element.login}
                                  src="/img/default_profile_photo.png"
                                  onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = '/img/default_profile_photo.png'; }}
                                  className="img-responsive"
                                  alt="profile"
                                />
                              </div>
                              <div className="intuitive-description">
                                {element.firstName || element.lastName ? element.firstName + " " + element.lastName.toUpperCase() : "UNKNWOWN USER"}</div>
                            </Link>
                          })}
                          <div ref={this.setWrapperRef} className="intuitive-result">
                            <button onClick={this.handleAdvancedSearchSubmit} className="dropdown-item">
                              <FormattedMessage id="home.more" defaultMessage="More" />
                            </button></div>
                        </div>
                      } */}
                      </div>
                      <div className="form-group col-md-2">
                        <button
                          type="button"
                          onClick={this.handleAdvancedSearchSubmit}
                          className="btn btn-success btn-success-engie right"
                        >
                          <i className="icon-magnifying-glass t2"></i> <FormattedMessage id="result.filter" defaultMessage="Filter" />
                        </button>
                      </div>
                    </div>
                    {!this.state.showFilters &&
                      <div className="marginbot">
                        <a href="# " role="button" onClick={this.showFilters} className="btn btn-success btn-success-engie ml-1" style={{ marginRight: '14px' }}>
                          + <FormattedMessage id="home.advanced_search" defaultMessage="Filters" />
                        </a>
                        <a href="# " role="button" onClick={this.clearFilters} className="btn btn-success btn-success-engie ml-1">
                          <FormattedMessage id="result.clearFilters" defaultMessage="Clear filters" />
                        </a>
                      </div>
                    }
                    {this.state.showFilters &&
                      <div>
                        <div className="marginbot">
                          <a href="# " role="button" onClick={this.showFilters} className="btn btn-success btn-success-engie ml-1" style={{ marginRight: '14px' }}>
                            - <FormattedMessage id="home.advanced_search" defaultMessage="Filters" />
                          </a>
                          <a href="# " role="button" onClick={this.clearFilters} className="btn btn-success btn-success-engie ml-1">
                            <FormattedMessage id="result.clearFilters" defaultMessage="Clear filters" />
                          </a>
                        </div>
                        <div className="form-row">
                          <div className="form-group col-md-3">
                            <label id="lastnameLabel"><FormattedMessage id="field.lastname" defaultMessage="Last name" /></label>
                            <input type="text" className="form-control" value={this.state.lastNameQuery} onChange={this.handleInputChange} id="lastNameQuery" />
                          </div>
                          <div className="form-group col-md-3">
                            <label id="firstnameLabel"><FormattedMessage id="field.firstname" defaultMessage="First name" /></label>
                            <input type="text" className="form-control" value={this.state.firstNameQuery} onChange={this.handleInputChange} id="firstNameQuery" />
                          </div>
                          <div className="form-group col-md-3">
                            <label id="groupIdLabel"><FormattedMessage id="field.groupid" defaultMessage="Group ID" /></label>
                            <input type="text" className="form-control" value={this.state.groupIdQuery} onChange={this.handleInputChange} id="groupIdQuery" />
                          </div>
                          <div className="form-group col-md-3">
                            <label id="employeeTypeLabel"><FormattedMessage id="field.employeetype" defaultMessage="Employee Type" /></label>
                            <select id="employeeTypeQuery" className="form-control" value={this.state.employeeTypeQuery} onChange={this.handleInputChange}>
                              <option value=""><FormattedMessage id="option.employeeType" defaultMessage="Internal/External" /></option>
                              <option value="I"><FormattedMessage id="option.internal" defaultMessage="Internal" /></option>
                              <option value="E"><FormattedMessage id="option.external" defaultMessage="External" /></option>
                            </select>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="form-group col-md-3">
                            <label id="gbuLabel"><FormattedMessage id="field.gbu" defaultMessage="GBU" /></label>
                            <select className="form-control" value={this.state.gbuQuery} onChange={this.handleInputChange} id="gbuQuery">
                              <option value=""></option>
                              {this.state.GBUs.map((element) => {
                                return <option key={element.Code} value={element.Code}>{element.Name}</option>;
                              })}
                            </select>
                          </div>
                          <div className="form-group col-md-3">
                            <label id="companyLabel"><FormattedMessage id="field.company" defaultMessage="Company" /></label>
                            <input type="text" className="form-control" value={this.state.companyQuery} onChange={this.handleInputChange} id="companyQuery" />
                          </div>
                          <div className="form-group col-md-3">
                            <label id="jobFamilyLabel"><FormattedMessage id="field.jobfamily" defaultMessage="Job family" /></label>
                            <select className="form-control" value={this.state.C_businessCategoryQuery} onChange={this.handleInputChange} id="C_businessCategoryQuery">
                              <option value=""></option>
                              {this.state.enum.JobFamilies.map((element) => {
                                return <FormattedMessage id={"field.jobfamily." + element} key={element}>
                                  {(message) => <option key={element} value={element}>{message ? message : element}</option>}
                                </FormattedMessage>;
                              })}
                            </select>
                          </div>
                          <div className="form-group col-md-3">
                            <label id="functionLabel"><FormattedMessage id="field.function" defaultMessage="Function" /></label>
                            <input type="text" className="form-control" value={this.state.titleQuery} onChange={this.handleInputChange} id="titleQuery" />
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="form-group col-md-3">
                            <label id="phonenumberLabel"><FormattedMessage id="field.phonenumber" defaultMessage="Phone number" /></label>
                            <input type="text" className="form-control" value={this.state.primaryPhoneQuery} onChange={this.handleInputChange} id="primaryPhoneQuery" />
                          </div>
                          <div className="form-group col-md-3">
                            <label id="countryLabel"><FormattedMessage id="field.country" defaultMessage="Country" /></label>
                            <select className="form-control" value={this.state.C_countryNameQuery} onChange={this.handleInputChange} id="C_countryNameQuery">
                              <option value=""></option>
                              {this.state.enum.Countries.map((element) => {
                                return <option key={element.id} value={element.name}>{element.name}</option>;
                              })}
                            </select>
                          </div>
                          <div className="form-group col-md-3">
                            <label id="cityLabel"><FormattedMessage id="field.city" defaultMessage="City" /></label>
                            <input type="text" className="form-control" value={this.state.cityQuery} onChange={this.handleInputChange} id="cityQuery" />
                          </div>
                          <div className="form-group col-md-3">
                            <label id="siteLabel"><FormattedMessage id="field.site" defaultMessage="Site" /></label>
                            <input type="text" className="form-control" value={this.state.C_houseIdentifierQuery} onChange={this.handleInputChange} id="C_houseIdentifierQuery" />
                          </div>
                        </div>
                      </div>
                    }
                  </form>
                </div>
                <div className="row mt-4 directory-results-row">
                  {this.state.results.length > 0 &&
                    this.state.results.map((element) => {
                      const a = this.state.results.indexOf(element);
                      const fullName = (element.firstName || "") + " " + (element.lastName || "");
                      return (
                        <Link
                          to={`/profile?userId=${encodeURIComponent(element.login)}`}
                          key={a}
                          className="card-link directory-card-col"
                          aria-label={`Ouvrir le profil de ${fullName}`}
                        >
                          <div
                            className="directory-card probootstrap-card probootstrap-person"
                            tabIndex={0}
                            data-userid={element.login}
                          >
                            <div className="directory-card-actions">
                              <span className="action-badge"><FormattedMessage id="profile.open" defaultMessage="Profile" /></span>
                            </div>
                            <div className="directory-photo" aria-hidden="true">
                              <img
                                id={element.login}
                                src="/img/default_profile_photo.png"
                                loading="lazy"
                                onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = '/img/default_profile_photo.png'; }}
                                alt={fullName.trim() ? fullName : 'Profile'}
                              />
                            </div>
                            <h3 className="directory-name" title={fullName}>{fullName}</h3>
                            {(element.customTitle || element.title) && (
                              <div className="directory-title" title={element.customTitle || element.title}>
                                {element.customTitle || element.title}
                              </div>
                            )}
                            {element.email && <div className="directory-email" title={element.email}>{element.email}</div>}
                            <div className="directory-hover-bar" aria-hidden="true">
                              <span className="hover-pill"><FormattedMessage id="profile.view" defaultMessage="View profile" /></span>
                            </div>
                          </div>
                        </Link>
                      );
                    })}
                </div>
                {this.state.ready && !this.state.isLoadingMore && this.state.results.length === 0 &&
                  <div className="alert-container">
                    <Alert
                      type="info"
                      title="No Results Found"
                      message="No users match your search criteria. Try adjusting your filters or search terms."
                    />
                  </div>
                }
                
                {/* Loading indicator for infinite scroll */}
                {this.state.isLoadingMore && (
                  <div className="text-center mt-4 mb-4">
                    <div className="loading-spinner" style={{ width: '2rem', height: '2rem' }}></div>
                    <p className="loading-text mt-2"><FormattedMessage id="loading.more" defaultMessage="Loading more results..." /></p>
                  </div>
                )}
              </div>
            </section>
          </div>
        )}
      </div>
    );
  }
});
